import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';

@Component({
  selector: 'section-rename',
  templateUrl: './section-rename.component.html',
  styleUrls: ['./section-rename.component.scss'],
})
export class SectionRenameComponent implements OnInit {    
  @Input() section: any;
  @Input() title: string;
  constructor( private modalCtrl: ModalController,
      private translate: TranslateService,
      public userAuthService: UserAuthService) { }

  get currentName(): string {
    return this.section?.sectionName ?? this.section?.subSectionName ?? '';
  }

  private set currentName(value: string) {
    if (!this.section) {
      return;
    }

    if (Object.prototype.hasOwnProperty.call(this.section, 'subSectionName')) {
      this.section.subSectionName = value;
      return;
    }

    this.section.sectionName = value;
  }
      
  ngOnInit() {   
    this.section.changedName = this.currentName;
  }
  
  closeModal(): void {
    this.modalCtrl.dismiss({
      dismissed: true
    });
  }
  
    /**
     * To cancel the modal
     */
  public cancel() {
    this.modalCtrl.dismiss({
      dismissed: true
    });
  }

  /**
   * API post save Static RA Template
   */
  submit(){
    this.currentName = String(this.section?.changedName || '').trim();
    this.modalCtrl.dismiss({
        section: this.section,
        dismissed: true
    });
    
  }
}
